import Padding from './src/padding.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';
export const ToPadding: SFCWithInstall<typeof Padding> = withInstall(Padding);
export * from './src/instance';
